import AclCondition from "../components/AclCondition";
import { connect } from "react-redux";

export default connect((state, ownProps) => ({
  ...ownProps,
  acl: state.acl,
}))(AclCondition);
